import { useMemo } from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_ADLE_MODULES_OPTIONS } from "../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND,
  ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES,
  ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT,
} from "../../../i18n/keysTranslations";
import CheckGroup from "../../PreActivation/components/CheckGroup";
import FieldBlock from "../../PreActivation/components/FieldBlock";
import FieldError from "../../PreActivation/components/FieldError";
import FieldHint from "../../PreActivation/components/FieldHint";
import FieldLabel from "../../PreActivation/components/FieldLabel";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import { ENTERPRISE_INTAKE_ORGANIZATION_TYPE_AGENCY } from "../enterpriseIntakeFormValues";
import BoldPrefixUntilColon from "./shared/BoldPrefixUntilColon";
import NumericFieldBlock from "./shared/NumericFieldBlock";
import { mapTranslatedOptions } from "./shared/mapTranslatedOptions";

const ScopeSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();
  const organizationType = useWatch({ control, name: "organizationType" });
  const isAgency =
    organizationType === ENTERPRISE_INTAKE_ORGANIZATION_TYPE_AGENCY;

  const moduleOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_ADLE_MODULES_OPTIONS,
        t,
      }).map((option) => ({
        ...option,
        label: <BoldPrefixUntilColon text={option.label} />,
      })),
    [t]
  );

  const brandsCountLabelKey = isAgency
    ? ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY
    : ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT;
  const brandsCountHintKey = isAgency
    ? ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY
    : ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND;

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="selectedAdleModules"
          text={t(ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES)}
          required
        />
        <FieldHint text={t(ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES)} />
        <Controller
          name="selectedAdleModules"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CheckGroup
                name="selectedAdleModules"
                options={moduleOptions}
                selectedValues={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>

      <NumericFieldBlock
        name="scopeBrandConfigsCount"
        labelKey={brandsCountLabelKey}
        hintKey={brandsCountHintKey}
        placeholderKey={ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT}
        required
        min={1}
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />
    </ReadOnlySectionGrid>
  );
};

export default ScopeSection;
